// @flow
import React from 'react';
import {Input} from 'reactstrap'
import AbstractField from "./AbstractField";


// TODO NOPEPARTS -- Podezřelá komponenta --
/**
 * Custom select field
 */
class CustomSelectField extends AbstractField {

    static PropTypes = {
        ...AbstractField.propTypes,
        items: React.PropTypes.array.isRequired,
        renderItem: React.PropTypes.func,
        getItemValue: React.PropTypes.func,
    };

    static defaultProps = {
        renderItem: (item, active) => <div className={active ? "active" : ""}>{active ? "#" : ""}{item.name}</div>,
        getItemValue: item => item ? item.id : null,
    };

    handleItemSelect = (item, e) => {
        const {onChange, getItemValue} = this.props;
        onChange(getItemValue(item));
    };

    render() {
        const {addonsBefore, addonsAfter, onChange, onBlur, onFocus, value, renderItem, getItemValue, items, key, disabled, ...props} = this.props;

        const itemsEl = items.map((item, index) => {
            const onClick = disabled ? null : this.handleItemSelect.bind(this, item);
            return <div onClick={onClick} key={'CustomSelectField-Item-' + index}>{renderItem(item, getItemValue(item) === value)}</div>
        });

        const field = <div
            {...props}
            key={key}
            disabled={disabled}
        >
            {itemsEl}
        </div>;

        return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
    }
}

export default CustomSelectField;
